import { axios } from '@Root/API'

export const getQR = () => {
  return axios.get('users-google-key')
}
